import React, { useState, useEffect } from 'react';
import {
  Box, Select, Text, useDisclosure, Modal, ModalOverlay, ModalContent,
  ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Button, Input,
  FormControl, FormLabel, useToast,
} from '@chakra-ui/react';
import api from '../api';

export default function ActionTypeSelect({ projectId }) {
  const [types, setTypes] = useState([]);
  const [editing, setEditing] = useState(false);
  const [selectedType, setSelectedType] = useState('');
  const newTypeModal = useDisclosure();
  const [newTypeName, setNewTypeName] = useState('');
  const toast = useToast();

  useEffect(() => {
    api.get('/actions/types').then(({ data }) => setTypes(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (projectId) {
      api.get(`/actions?project_id=${projectId}`).then(({ data }) => {
        if (data.length > 0) {
          setSelectedType(data[0].type_name || '');
        }
      }).catch(() => {});
    }
  }, [projectId]);

  const handleChange = async (e) => {
    const val = e.target.value;
    if (val === '__new__') {
      setEditing(false);
      setNewTypeName('');
      newTypeModal.onOpen();
      return;
    }
    if (val) {
      try {
        await api.post('/actions', {
          project_id: projectId,
          action_type_id: parseInt(val),
          action_date: new Date().toISOString().split('T')[0],
        });
        const type = types.find(t => t.id === parseInt(val));
        setSelectedType(type?.name || '');
      } catch (err) {
        toast({ title: 'Failed to add action', status: 'error', duration: 2000 });
      }
    }
    setEditing(false);
  };

  const handleCreateType = async () => {
    if (!newTypeName.trim()) return;
    try {
      const { data } = await api.post('/actions/types', { name: newTypeName.trim() });
      setTypes(prev => [...prev, data].sort((a, b) => a.name.localeCompare(b.name)));
      setNewTypeName('');
      newTypeModal.onClose();
      toast({ title: `Type "${data.name}" created`, status: 'success', duration: 2000 });
    } catch (err) {
      toast({ title: err.response?.data?.error || 'Failed', status: 'error', duration: 2000 });
    }
  };

  return (
    <>
      {!editing ? (
        <Box
          cursor="pointer"
          onClick={() => setEditing(true)}
          minH="20px"
          fontSize="12px"
          color={selectedType ? 'gray.800' : 'gray.400'}
          _hover={{ borderRadius: 'sm' }}
          px={1}
          py={0.5}
        >
          <Text noOfLines={1}>{selectedType || 'Select type...'}</Text>
        </Box>
      ) : (
        <Select
          size="xs"
          fontSize="12px"
          onChange={handleChange}
          onBlur={() => setTimeout(() => setEditing(false), 200)}
          autoFocus
          defaultValue=""
          
          
          
          
          
          
        >
          <option value="">— Select Type —</option>
          {types.map(t => (
            <option key={t.id} value={t.id}>{t.name}</option>
          ))}
          <option value="__new__">+ Add new type...</option>
        </Select>
      )}

      {/* Modal rendered outside the editing conditional so it stays mounted */}
      <Modal isOpen={newTypeModal.isOpen} onClose={newTypeModal.onClose} size="xs">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize="sm">New Action Type</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel fontSize="xs">Type Name</FormLabel>
              <Input
                size="sm"
                value={newTypeName}
                onChange={(e) => setNewTypeName(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleCreateType()}
                autoFocus
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button size="sm" variant="ghost" mr={2} onClick={newTypeModal.onClose}>Cancel</Button>
            <Button size="sm" bg="brand.600"  _hover={{ bg: 'brand.700' }} onClick={handleCreateType}>
              Create
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
